import { index, jsonb, pgEnum, pgTable, text, timestamp } from "drizzle-orm/pg-core";

export const botJobTypeEnum = pgEnum("bot_job_type", ["FANATICS_BUY"]);

export const botJobStatusEnum = pgEnum("bot_job_status", [
  "PENDING",
  "CLAIMED",
  "COMPLETED",
  "FAILED",
]);

/**
 * Bot worker jobs (Fanatics buy cards). Ported from boxed Dynamo Job table —
 * claim/complete/fail with a releasesAt lease for stale CLAIMED recovery.
 */
export const botJobs = pgTable(
  "bot_jobs",
  {
    id: text("id").primaryKey(),
    type: botJobTypeEnum("type").notNull(),
    status: botJobStatusEnum("status").notNull(),
    payload: jsonb("payload").notNull().$type<Record<string, unknown>>(),
    workerId: text("worker_id"),
    releasesAt: timestamp("releases_at", { withTimezone: true }),
    result: jsonb("result").$type<Record<string, unknown>>(),
    failureReason: text("failure_reason"),
    failureData: jsonb("failure_data").$type<Record<string, unknown>>(),
    createdAt: timestamp("created_at", { withTimezone: true }).notNull().defaultNow(),
    updatedAt: timestamp("updated_at", { withTimezone: true }).notNull().defaultNow(),
  },
  (t) => [index("bot_jobs_type_status_created_idx").on(t.type, t.status, t.createdAt)],
);
